import React, { useEffect, useState } from "react";
import { getStore, updateStore } from "../storage";

export default function StoreMaster() {
  const [form, setForm] = useState({ name: "", gstNumber: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  useEffect(() => {
    getStore().then((data) => setForm({ name: data.name || "", gstNumber: data.gstNumber || "" }))
      .catch((err) => setError(err.message)).finally(() => setLoading(false));
  }, []);
  const save = async (event) => {
    event.preventDefault();
    setSaving(true); setError(""); setMessage("");
    try { setForm(await updateStore(form)); setMessage("Store details saved."); }
    catch (err) { setError(err.message); }
    finally { setSaving(false); }
  };
  return <div className="stock-inward-container"><div className="form-card">
    <div className="card-header"><h2 className="card-title">Store Master</h2></div>
    {error && <p role="alert">{error}</p>}{message && <p role="status">{message}</p>}
    {loading ? <p>Loading store details...</p> : <form className="inward-form" onSubmit={save}>
      <div className="form-grid">
        <label>Store Name<input className="input-field" required maxLength={190} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></label>
        <label>GST Number (optional)<input className="input-field" maxLength={15} value={form.gstNumber} onChange={(e) => setForm({ ...form, gstNumber: e.target.value.toUpperCase() })} /></label>
      </div>
      <button className="btn-primary" disabled={saving}>{saving ? "Saving..." : "Save Store"}</button>
    </form>}
  </div></div>;
}
